<template>
  <div class="content content-aligned">
    <h1>Lær at lave et scrollerspil</h1>
    <p>Følg vejledningerne i disse tre videoer, hvor du vil lære at lave dit eget scrollerspil.</p>
    <p>Hav en fane åben med videoerne og en anden fane med Scratch/CodingLab, hvor du koder dit spil.</p>
    <p>Sæt videoerne på pause undervejs, imens du koder.</p>

    <div class="content--centered">
      <EmbedYoutube id="F_PmSvUpsQM" title="Step 1" />
      <EmbedYoutube id="ZdGKkODDLkQ" title="Step 2" />
      <EmbedYoutube id="EfM4262Ungg" title="Step 3" />
    </div>
  </div>
</template>

<script>
import EmbedYoutube from "@/components/YoutubeEmbed";

export default {
  name: "VideoTutScroller",
  components: {
    EmbedYoutube
  },
};
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/pages/video-tutorials/video-tut-scroller.vue